import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';

export interface DiagnosisCodingConfiguration {
  readonly activeVersion: string;
}

const genericConfiguration: DiagnosisCodingConfiguration = { activeVersion: 'ICD' };

@Injectable({ providedIn: 'root' })
export class DiagnosisCodingService {
  private configuration?: Observable<DiagnosisCodingConfiguration>;

  constructor(private readonly httpClient: HttpClient) {}

  getConfiguration(): Observable<DiagnosisCodingConfiguration> {
    if (!this.configuration) {
      this.configuration = this.loadConfiguration();
    }

    return this.configuration;
  }

  private loadConfiguration(): Observable<DiagnosisCodingConfiguration> {
    return this.httpClient
      .get<BaseRespone<DiagnosisCodingConfiguration>>(`${environment.baseURl}/ICD/configuration`)
      .pipe(
        map(response => response.result),
        catchError(() => of(genericConfiguration)),
        shareReplay({ bufferSize: 1, refCount: false })
      );
  }
}
